import { useMemo } from 'react';
import {
  AnnuityTaxStatus,
  getAnnuityTaxStatus,
} from '../../../../../../../../../Profile/Accounts/Features/AccountPreferences/components/AccountForm/AccountForm.meta';
import { OwnerModelDTO } from '../../../../../../../../../Profile/Accounts/api/useAccountsQuery';
import { useSourceAccountsQuery } from '../../api/useSourceAccountsQuery';

interface Params {
  year: number | null;
  accountOwner: string | null;
  ownerModel: OwnerModelDTO[] | null;
  fpId: string;
  annuityIsQualified: boolean | null;
  annuityIsRoth: boolean | null;
  isApplied: boolean;
}

export const usePurchaseAmountForm = ({
  year,
  accountOwner,
  ownerModel,
  fpId,
  annuityIsQualified,
  annuityIsRoth,
  isApplied,
}: Params) => {
  const annuityTaxStatus = getAnnuityTaxStatus({
    AnnuityIsQualified: annuityIsQualified,
    AnnuityIsRoth: annuityIsRoth,
  });

  const queryResult = useSourceAccountsQuery({
    year,
    fpId,
    accountOwner: ownerModel?.length ? ownerModel[0].Name : accountOwner, // Annuity has single owner
    isApplied,
  });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return {
        accountOptions: [],
        sourceAccounts: [],
      };
    }

    const {
      SourcesForNonQualifiedAnnuities,
      SourcesForQualifiedAnnuities,
      SourcesForRothAnnuities = [],
    } = queryResult.data;

    const sourceAccounts =
      annuityTaxStatus === AnnuityTaxStatus.Roth
        ? SourcesForRothAnnuities
        : annuityTaxStatus === AnnuityTaxStatus.Qualified
        ? SourcesForQualifiedAnnuities
        : SourcesForNonQualifiedAnnuities;

    return {
      sourceAccounts,
      accountOptions: sourceAccounts.map(source => ({
        label: source.Name,
        value: source.Id,
        metaData: {
          SimulatedAccountType: source.SimulatedAccountType,
          IsSimulatedSource: source.IsSimulatedSource,
          EntityId: source.EntityId,
        },
      })),
    };
  }, [annuityTaxStatus, queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
